import { IDropdownOption } from "../../ui/product-form/_reducers/_utils/product-form-types"

export const isLongerThan = (b: number) => (a: string | any[]) => a.length > b
export const isShorterThan = (b: number) => (a: string | any[]) => a.length < b
export const hasSizeEqualTo = (b: number) => (a: string | any[]) =>
  a.length === b
export const ensureVarietyOfCharacters = (a: string | any[]) => {
  if (a.length <= 0) {
    return true
  }
  for (const letter of a) {
    if (letter !== a[0]) {
      return true
    }
  }
  return false
}

export const isNumber = (value: any) => !isNaN(value)
export const isNotEmptyString = (value: any) => !!value
export const hasUpperCase = (value: any) => value !== value.toLowerCase()

export const shouldContain =
  (...characters: string[]) =>
  (value: string) =>
    characters.every((char) => value.includes(char))

export const shouldContainAnyOf =
  (...characters: string[]) =>
  (value: string) =>
    characters.some((char) => value.includes(char))

// export const isGuid = (str: string) => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(str)
// export const isNotGuid = (str: string) => !isGuid(str)
export const isDroopyGuid = (str: string) =>
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}$/.test(str)
export const isNotDroopyGuid = (str: string) => !isDroopyGuid(str)
export const isNotMoreThan20Chars = (str: string) => str.length <= 20
export const isNotMoreThan200Chars = (str: string) => str.length <= 200

export const isCustomsCode = (str: string) => /^[0-9]{8}$/gm.test(str)
export const isCustomsCodeByOption = (
  str: string,
  options?: IDropdownOption[]
): boolean => !!options?.find((x) => x.value === str)
